import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=22364c5b&"
import script from "./todoList.vue?vue&type=script&lang=ts&"
export * from "./todoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports